/* eslint-disable react-hooks/exhaustive-deps */
import SliderLayoutProvider from './hooks/useSliderLayout';
import React from 'react';
import { SliderLayoutProps } from './@types/SliderLayoutProps';
import SliderLayoutContainer from './handles/SliderLayoutContainer';
import SliderTrackContainer from './handles/SliderTrackContainer';
import SliderLeftArrow from './handles/SliderLeftArrow';
import SliderRightArrow from './handles/SliderRightArrow';
import SliderTrack from './handles/SliderTrack';
import Slide from './handles/Slide';
import SlideChildrenContainer from './handles/SlideChildrenContainer';
import PaginationDotsContainer from './handles/PaginationDotsContainer';
import PaginationDot from './handles/PaginationDot';
import { useEffect, useState } from 'react';
import { selectedToggleValue } from '../../../redux/canvasResolutionSlice';
import { useSelector } from 'react-redux';
import { useListContext } from '../../list-context/ListContextProvider';
import useResponsiveValue from '../../responsive-values/useResponsivevalue';

type CanvasWidth = {
	canvasWidth: 1920 | 1024 | 467;
};

type AllProps = SliderLayoutProps & CanvasWidth;

const SliderLayout = ({ canvasWidth, ...rest }: AllProps) => {
	const list = useListContext()?.list ?? [];
	const arrowSize = useResponsiveValue(rest.arrowSize);
	const responsiveItems = useResponsiveValue(rest.itemsPerPage);
	const responsiveCenterMode = useResponsiveValue(rest.centerMode);
	const [images, setImages] = useState<any[]>([]);
	const selectedCanvasResolution = useSelector(selectedToggleValue) as 1920 | 1024 | 467;
	const [items, setItems] = useState<number[]>([]);

	// const responsiveItems = {
	//     1920: rest.itemsPerPage?.desktop || 4,
	//     1024: rest.itemsPerPage?.tablet || rest.itemsPerPage?.mobile || 4,
	//     467: rest.itemsPerPage?.phone || rest.itemsPerPage?.mobile || 4,
	// };
	// const arrowSize = {
	//     1920: rest.arrowSize?.desktop || 25,
	//     1024: rest.arrowSize?.tablet || 25,
	//     467: rest.arrowSize?.mobile || 25
	// }

	useEffect(() => {
		const slides = React.Children.toArray(rest.children || []).concat(list);
		setImages(slides);

		setItems(new Array(responsiveItems).fill(0));
	}, [selectedCanvasResolution, rest.itemsPerPage, list, responsiveItems, rest.children]);
	return (
		<SliderLayoutProvider {...rest} componentId={rest.componentId}>
			<SliderLayoutContainer arrowSize={arrowSize} fullWidth={rest.fullWidth}>
				<SliderTrackContainer>
					<SliderTrack centerMode={responsiveCenterMode ?? 'disabled'}>
						{images?.map((item: any, index: number) => {
							if (item?.props?.comp?.componentName === 'ProductSummaryShelfComponent') {
								return items.map((el, slideIndex) => (
									<Slide
										{...{
											centerMode: responsiveCenterMode ?? 'disabled',
											centerModeSlidesGap: rest.centerModeSlidesGap,
											slidesPerPage: responsiveItems,
										}}
										key={`productslide-${slideIndex}`}
									>
										<SlideChildrenContainer>{item}</SlideChildrenContainer>
									</Slide>
								));
							}

							if (index < items.length) {
								return (
									<Slide key={`imageslide-${index}`}>
										<SlideChildrenContainer>{item}</SlideChildrenContainer>
									</Slide>
								);
							}

							return null;
						})}
					</SliderTrack>
				</SliderTrackContainer>

				<SliderArrows
					arrowSize={arrowSize}
					{...{ showNavigationArrows: rest.showNavigationArrows, selectedCanvasResolution }}
				/>

				<PaginationDots {...{ showPaginationDots: rest.showPaginationDots, selectedCanvasResolution }} />
			</SliderLayoutContainer>
		</SliderLayoutProvider>
	);
};

const SliderArrows = ({ showNavigationArrows, selectedCanvasResolution, arrowSize }: any) => {
	if (
		showNavigationArrows == 'always' ||
		(showNavigationArrows == 'desktopOnly' && selectedCanvasResolution > 1024) ||
		(showNavigationArrows == 'mobileOnly' && selectedCanvasResolution <= 1024)
	) {
		return (
			<>
				<SliderLeftArrow arrowSize={arrowSize} />
				<SliderRightArrow arrowSize={arrowSize} />
			</>
		);
	}
	return null;
};

const PaginationDots = ({ showPaginationDots, selectedCanvasResolution }: any) => {
	//fazendo com que sempre tenham 4 pagination dots, melhor para desenvolver e customizar
	const dots = new Array(4).fill(0);
	if (
		showPaginationDots == 'always' ||
		(showPaginationDots == 'desktopOnly' && selectedCanvasResolution > 1024) ||
		(showPaginationDots == 'mobileOnly' && selectedCanvasResolution <= 1024)
	) {
		return (
			<PaginationDotsContainer>
				{dots.map((_: any, index: any) => (
					<PaginationDot key={`dot-${index}`} isActive={index === 0} />
				))}
			</PaginationDotsContainer>
		);
	}
	return null;
};
export default SliderLayout;
